import HttpService from 'ui-home/src/misc/HttpService/HttpService';
import { setJitaEnabledAccount } from 'ui-common/src/utils/LoginActions';
import { removeMenuById } from '../utils/removeMenuByID/removeMenuByID';


export const SIDE_MENU_LOADING = 'SIDE_MENU_LOADING';
export const SIDE_MENU_LOADED = 'SIDE_MENU_LOADED';
export const UPDATE_MENU_FILTER = 'UPDATE_MENU_FILTER';

const sideMenuLoading = () => ({ type: SIDE_MENU_LOADING, loading: true });

const InitializeSideMenu = (featureFlags) => (dispatch) => {
  dispatch(sideMenuLoading());
  const response = HttpService.get('/ECM/navigation/leftNav', { 'X-NOERRORMODAL': true });

  const { isEmergencyRolesUser, isIntegration } = featureFlags;

  response.then((res) => {
    let sideMenu = [...res.topLevel];

    if (!isEmergencyRolesUser) {
      sideMenu = removeMenuById(sideMenu, 'request-emergency-access-roles');
    }
    if (isIntegration) {
      sideMenu = removeMenuById(sideMenu, 'design');
    } else {
      sideMenu = removeMenuById(sideMenu, 'integrations');
    }

    // Derive isJitaEnabled from the backend left nav response.
    // If the response contains 'jita-sessions' or 'jit-access', the user is a JITA user.
    const hasJitaNavItem = res.topLevel.some(
      (menu) => menu.id === 'jit-access' || menu.subMenu?.some((sub) => sub.id === 'jita-sessions')
    );
    dispatch(setJitaEnabledAccount(hasJitaNavItem));

    dispatch({
      type: SIDE_MENU_LOADED,
      data: sideMenu,
    });
  });
};

const updateMenuFilter = (menuId, isEnabled) => (dispatch, getState) => {
  const state = getState();
  const currentFilter = state.app?.menuFilters?.[menuId];
  const rawSideMenu = state.app?.rawSideMenu;

  // Only update if conditions are met
  if (rawSideMenu?.length && currentFilter !== isEnabled) {
    dispatch({
      type: UPDATE_MENU_FILTER,
      menuId,
      isEnabled,
    });
  }
};

export { InitializeSideMenu, updateMenuFilter };
